import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-image-preview-popover',
  templateUrl: './image-preview-popover.component.html',
  styleUrls: ['./image-preview-popover.component.css'],
})
export class ImagePreviewPopoverComponent implements OnInit {
  @Input() imagePreviewLink: string = '';
  constructor() {}

  ngOnInit(): void {}
}
